<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-file-find</v-icon>
                <span class="title font-weight-light">Configuração do Relatório de Log</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-form id="form" ref="form" v-model="valid" lazy-validation>
                    <v-row>
                        <v-col cols="12" sm="8" md="8">
                            <v-autocomplete v-model="filtro.usuarioId" :items="usuarios" :loading="isUsuarioLoading" :search-input.sync="onSearchUsuario" clearable
                            item-text="nome" item-value="id" label="Usuário" dense outlined/>
                        </v-col>   
                        <v-col cols="12" sm="4" md="4">
                            <v-select v-model="filtro.operacao" label="Operação" :items="operacoes" item-value="Key" item-text="Nome" dense outlined/>
                        </v-col>                 
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataInicio" label="Data de início" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataInicio" no-title/>
                            </v-menu>
                        </v-col>   
                        <v-col cols="12" sm="6" md="6">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataFim" label="Data de término" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataFim" no-title/>
                            </v-menu>
                        </v-col>   
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </master-page>
</template>

<script>
import UsuarioService from '../../../core/services/geral/UsuarioService';

export default {
    data: () => ({
        filtro: {            
            dataInicio: null,            
            dataFim: null,
            usuarioId: 0,
            operacao: "",
            ordenacao: "DataHora"
        },
        valid: true,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],   
        operacoes:[
            {
                Nome:"Todos",
                Key:""
            },
            {
                Nome:"Alteração",
                Key:"Alteração"
            },
            {
                Nome:"Inclusão",
                Key:"Inclusão"
            },
            {
                Nome:"Exclusão",
                Key:"Exclusão"
            },
        ],
        usuarioService: new UsuarioService(),
        usuarios: [],
        isUsuarioLoading: false,
        onSearchUsuario: null
    }),
    watch:{
        onSearchUsuario(val){
            if(this.isUsuarioLoading) return;
            if(!val) return;
            if(this.filtro.usuarioId > 0) return;

            this.isUsuarioLoading = true;
            this.usuarioService.AutoComplete(val)
            .then(
                res=>{
                    this.usuarios = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isUsuarioLoading = false))
        }
    },
    methods: {
        GerarRelatorio(){
            if( this.$refs.form.validate()){
                this.AbrirJanela('relatorioLogUtilizacao')
            }
        },
        LimparFiltros(){
            this.filtro = {
                dataInicio: null,            
                dataFim: null,
                usuarioId: 0,
                operacao: "",
                ordenacao: "DataHora"
            }
        },
        AbrirJanela(rota) {
            let routeLink = this.$router.resolve({ name: rota,
                query:{
                    dataInicio: this.filtro.dataInicio,
                    dataFim: this.filtro.dataFim,
                    usuarioId: this.filtro.usuarioId,
                    operacao: this.filtro.operacao,
                    ordenacao: this.filtro.ordenacao
                } 
            });
            window.open(routeLink.href,'_blank');
        },
    },
    mounted(){
        
    }
}

</script>